module.exports = __webpack_public_path__ + "img/lang-en-hover.77f49817.png";